import NextNprogress from "nextjs-progressbar";
import { useColorModeValue } from "@chakra-ui/react";
import { colors } from "@/theme/colors";

export const PageLoadProgress = () => {
  // interactive-01 semantic color
  const defaultColor = useColorModeValue(colors.acid["200"], colors.acid["200"]);
  return <NextNprogress options={{ showSpinner: false }} color={defaultColor} />;
};
